import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './Guards/auth.guard';
import { roleGuard } from './Guards/role.guard';
import { NgModule } from '@angular/core';
import { maintenanceGuard } from './Guards/maintenance.guard';
import { bufferStockGuard } from './Guards/bufferstock.guard';

export const routes: Routes = [
    //Default Route
    { path: '', redirectTo: '/login', pathMatch: 'full' },

    {
        path: 'login',
        loadComponent: () =>
            import('./Pages/login/login.component').then(
                (c) => c.LoginComponent,
            ),
        title: 'Login',
    },
    {
        path: 'home',
        loadComponent: () =>
            import('./Pages/landing/landing.component').then(
                (c) => c.LandingComponent,
            ),
        title: 'Home',
        canActivate: [authGuard, maintenanceGuard],
    },
    {
        path: 'delivery-dashboard',

        loadComponent: () =>
            import('./Pages/dashboard/dashboard.component').then(
                (c) => c.DashboardComponent,
            ),
        canActivate: [authGuard, maintenanceGuard], //UNlock before merging to main
    },
    {
        path: 'create-delivery',
        loadComponent: () =>
            import('./Pages/create-delivery/create-delivery.component').then(
                (c) => c.CreateDeliveryComponent,
            ),
        canActivate: [authGuard, maintenanceGuard], //UNlock before merging to main
    },
    {
        path: 'po-management',
        loadComponent: () =>
            import('./Pages/po-management/po-management.component').then(
                (c) => c.PoManagementComponent,
            ),
        canActivate: [authGuard, maintenanceGuard], //UNlock before merging to main
    },
    {
        path: 'bufferstock',
        loadComponent: () =>
            import('./Pages/bufferstock/bufferstock.component').then(
                (c) => c.BufferStockComponent,
            ),
        title: 'Buffer stock',
        canActivate: [authGuard, maintenanceGuard, bufferStockGuard],
        canDeactivate: [(component: { canLeave: () => boolean }) => component.canLeave()],
    },
    {
        path: 'admin-dashboard',
        loadComponent: () =>
            import('./Pages/admin-dashboard/admin-dashboard.component').then(
                (c) => c.AdminDashboardComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
    {
        path: 'admin-user-management',
        loadComponent: () =>
            import('./Pages/admin-user-management/admin-user-management.component').then(
                (c) => c.AdminUserManagementComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
    {
        path: 'admin-orders',
        loadComponent: () =>
            import('./Pages/admin-orders/admin-orders.component').then(
                (c) => c.AdminOrdersComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
    {
        path: 'admin-settings',
        loadComponent: () =>
            import('./Pages/admin-settings/admin-settings.component').then(
                (c) => c.AdminSettingsComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
    {
        path: 'admin-logs',
        loadComponent: () =>
            import('./Pages/admin-logs/admin-logs.component').then(
                (c) => c.AdminLogsComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
    {
        path: 'admin-quality-control',
        loadComponent: () =>
            import('./Pages/admin-quality-control/admin-quality-control.component').then(
                (c) => c.AdminQualityControlComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
    {
        path: 'admin-metrics',
        loadComponent: () =>
            import('./Pages/admin-metrics/admin-metrics.component').then(
                (c) => c.AdminMetricsComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
    {
        path: 'samples-management',
        loadComponent: () =>
            import('./Pages/samples-management/samples-management.component').then(
                (c) => c.SamplesManagementComponent,
            ),
        canActivate: [authGuard, maintenanceGuard],
    },
    {
        path: 'under-maintenance',
        loadComponent: () =>
            import('./Pages/under-maintenance/under-maintenance.component').then(
                (c) => c.UnderMaintenanceComponent,
            ),
        title: 'Under Maintenance',
        canActivate: [authGuard],
    },
    {
        path: 'reset-password',
        loadComponent: () =>
            import('./Components/reset-password/reset-password.component').then(
                (c) => c.ResetPasswordComponent,
            ),
        title: 'Reset Password',
    },
    {
        path: 'freight-forwarder-deliveries',
        loadComponent: () =>
            import('./Pages/freight-forwarder-deliveries/freight-forwarder-deliveries.component').then(
                (c) => c.FreightForwarderDeliveriesComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN', 'FREIGHT_FORWARDER'] },
    },
    {
        path: 'manage-deliveries',
        loadComponent: () =>
            import('./Pages/supplier-manage-deliveries/supplier-manage-deliveries.component').then(
                (c) => c.SupplierManageDeliveriesComponent,
            ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] },
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
        }),
    ],
})
export class AppRoutingModule {}
